import { render, staticRenderFns } from "./UserAdminOrgSelectionTemplate.vue?vue&type=template&id=4cc4c8f2&scoped=true&"
import script from "./UserAdminOrgSelectionTemplate.vue?vue&type=script&lang=js&"
export * from "./UserAdminOrgSelectionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4c8f2",
  null
  
)

export default component.exports